import { useState } from 'react'

interface FavoritoButtonProps {
  isFavorito?: boolean
  onClick?: () => void
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

/**
 * Bottone cuore per aggiungere/rimuovere dai preferiti
 * Attualmente mock - la logica sarà implementata con il backend
 */
export default function FavoritoButton({
  isFavorito = false,
  onClick,
  size = 'md',
  className = '',
}: FavoritoButtonProps) {
  const [animating, setAnimating] = useState(false)

  // Dimensioni per variante
  const sizeStyles = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
  }

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    // Animazione
    setAnimating(true)
    setTimeout(() => setAnimating(false), 300)

    onClick?.()
  }

  return (
    <button
      onClick={handleClick}
      className={`
        ${sizeStyles[size]}
        rounded-full
        flex items-center justify-center
        transition-all duration-200
        ${isFavorito
          ? 'bg-blood/80 text-white hover:bg-blood'
          : 'bg-night/80 text-gray-400 hover:text-blood hover:bg-night'
        }
        backdrop-blur-sm
        focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-night
        ${className}
      `}
      aria-label={isFavorito ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti'}
      aria-pressed={isFavorito}
    >
      <svg
        className={`
          ${iconSizes[size]}
          ${animating ? 'animate-heart' : ''}
          transition-transform duration-200
        `}
        fill={isFavorito ? 'currentColor' : 'none'}
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
    </button>
  )
}
